import React, { useMemo } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import { MultiSelectOption } from 'controlled-components'
import {
  removeBottomSelectedItem,
  selectBottomSelectedItemsData,
} from 'slices/aiSegmentBuilder/picker'

// ═══════════════════════════════════════════════════════════════════════════
// Types
// ═══════════════════════════════════════════════════════════════════════════

interface OwnProps {
  pickerId: number
}

interface DataItem {
  id: string
  name: string
}

type Props = OwnProps & ConnectedProps<typeof connector>

// ═══════════════════════════════════════════════════════════════════════════
// Component
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Sub-container for displaying selected items.
 * Renders MultiSelectOption for each selected item.
 */
const SelectionListContainer: React.FC<Props> = ({
  pickerId,
  selectedItemsData,
  removeSelectedItem,
}) => {
  // Derived: convert hash to array
  const selectedItems: DataItem[] = useMemo(
    () => Object.values(selectedItemsData),
    [selectedItemsData]
  )

  // Handler - in selection view, clicking removes the item
  const handleOptionSelect = (key: string) => {
    removeSelectedItem({ pickerId, key })
  }

  return (
    <>
      {selectedItems.map(item => (
        <MultiSelectOption
          key={item.id}
          value={item.id}
          selected={true}
          onSelect={handleOptionSelect}
        >
          {item.name}
        </MultiSelectOption>
      ))}
    </>
  )
}

// ═══════════════════════════════════════════════════════════════════════════
// Redux Connection
// ═══════════════════════════════════════════════════════════════════════════

const mapStateToProps = (state: any, ownProps: OwnProps) => ({
  selectedItemsData: selectBottomSelectedItemsData(state, ownProps.pickerId),
})

const mapDispatchToProps = {
  removeSelectedItem: removeBottomSelectedItem,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(SelectionListContainer)
